<template>
  <div>
    <div :class="'container ' + pageContainerSize">
     <div v-if="debug_show_page_name==true" style="color:green;">application-confirmation-modal</div>
     <modal id="confirmationModal" :backdrop="false" class="bulk-import-confirmation-modal" width="1100px" :value="showModal" :v-if="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header" >
        <h4 class="modal-title" style="">
          <strong>{{title}}</strong>
          <strong>{{userDepartment}}</strong>
        </h4>
      </div>
      <div v-if="showModal" class="modal-body bulk-import-confirmation-modal-body overflow-modal-body" :style="'height:600px'+';padding: 5px 15px; '">
        <table style="width:100%">
          <tr>
            <th style="width:10%"></th>
            <th style="width:10%">申請者</th>
            <th style="width:32%"></th>
            <th style="width:32%"></th>
            <th style="width:16%"></th>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>{{ teamApplicant }}</td>
            <td>{{ userApplicant }}</td>
                        <td>
              <div class="col-xs-12" style="">
                <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f" :read="readOnly" :val="values[f.id]"></field-box>
              </div>
                </td>
          </tr>
          <tr>
            <th style="width:10%"></th>
            <th style="width:10%">承認者</th>
            <th style="width:32%"></th>
            <th style="width:32%"></th>
            <th style="width:16%"></th>
          </tr>
           <tr v-for="n in ApprovalNumberSet" :key="n">
               <td>{{n}}.</td>
               <td :id="lastChange"></td>
                <td>
                  <div class="col-xs-12" style="">
                     <field-box :data="local_extend(localFields['team_' + n])" :read="readOnly" :val="values[localFields['team_' + n].id]"></field-box>
                  </div>
                </td>
                <td>
                  <div class="col-xs-12" style="">
                     <field-box :data="local_extend(localFields['approver_' + n])" :read="readOnly" :val="values[localFields['approver_' + n].id]"></field-box>
                  </div>
                </td>
                <td>
                  <div class="col-xs-12" style="">
                     <field-box :data="local_extend(localFields['status_' + n])" :read="readOnly" :val="values[localFields['status_' + n].id]"></field-box>
                  </div>
                </td>
          </tr>
           <tr v-if="applicationMode != 'mode_inventory'">
            <td>
              <div class="col-xs-13" style="">最終承認</div>
            </td>
            <td>
              <div class="col-xs-12" style=""></div>
            </td>
            <td>
              <div class="col-xs-13" style="">ライセンス管理窓口（最終承認）</div>
            </td>
            <td>
              <div class="col-xs-12" style="">
                <field-box   v-for="f in formFields.col5"  :key="f.id" :data="f" :read="readOnly" :val="values[f.id]"></field-box>
                </div>
            </td>
            <td>
              <div class="col-xs-12" style=""><field-box   v-for="f in formFields.col6"  v-bind:key="f.id" v-bind:data="f" :read="readOnly" :val="values[f.id]"></field-box></div>
            </td>
           </tr>
        </table>
      </div>
      <div slot="modal-footer" class="modal-footer no_focus" style="background:white">
        <span style="float: left;" v-if="application_mode!='inventory'">{{approvalHistoryTorokuNumber}}</span>
        <button :disabled="disableBtnApply"
        type="button" style="width:120px;"  :class="'btn btn-primary '" @click="onLocalApplication" v-show="modalIsReadOnly != true" >申請</button>
        <button type="button" style="width:120px;" :class="'btn btn-default ' " @click="closed('no')">戻る</button>
      </div>
     </modal>
    </div>
    <confirmation-modal tag="applicationConfirmatioModal" @done="onSaveApplicationConfirm" />
    <confirmation-modal tag="confirmDeviceEmbeddedInformation" @done="onSave" />
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
import constants from "@/rules/constants";
import { fields, filed_types } from '@/rules/fields_approval_history_inventory';
import fieldBoxes from '@/components/form-field';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
var vm = this;
import moment from 'moment';
import _ from 'lodash';

import  modal  from "./local-modal";
Vue.component("modal", modal);

import debug from "debug";
var debug_msg = debug("esma:application-confirmation-modal");
var debug_msg_bulk = debug("esma:application-confirmation-modal:bulk");

const MODE_DEVICE_EMBEDDED = "mode_device_embedded";
const MODE_CERTIFICATE = "mode_certificate";
const MODE_BULK_IMPORT = "mode_bulk_import";
const MODE_BULK_EDIT_DEVICEE_EMBEDDED = "mode_bulk_edit_device_embedded";
const MODE_BULK_EDIT_CERTIFICATE = "mode_bulk_edit_certificate";
const MODE_USER = "mode_user";
const MODE_INVENTORY = "mode_inventory";

export default {
  mixins: [mixinPageCommon,mixinDatasource],
  components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      show_modal: false,
      callback:null,
      model_height:"350",
      team_options:[],
      user_options:[],
      local_user_list:[],
      application_mode: null,
      ref_id: null,
      seq_id:null,
      approval_status:null,
      status:null,
      process_import_url:null,
      title_prefix:null,
      title_suffix:null,
      syubetu:null,
      list_team_department:[],
      selected_department:[],
      last_change:0,
      list_seq_id:null,
      fk_table_id :-1,
      state_current_editing:"current_editing3",
      state_current_row:"current_row3",
      state_is_editing_new:"is_editing_new3",
      state_last_filter_options:"last_filter_options3",
      modal_is_read_only:false,
      approval_history_id:"",
      disable_btn_apply:false,
      approval_history_toroku_number:"",
      session_id:false,
      user_applicant:"-",
      team_applicant:"--",
      is_surplus:false

    };
  },
  computed: {
    MaxNumberApproval(){
      switch (this.application_mode) {
          case "inventory":
            var maxnum = constants.INVENTORY.INVENTORY_APPROVAL_Number;
            break;
          default:
            var maxnum = 5;
            break;
        }
      return maxnum; 
    },
    ApprovalNumberSet(){
        return [...Array(this.MaxNumberApproval)].map((_, i) => i + 1);
    },
    userApplicant:{
      get(){
        // if( this.getFieldLastValue("current_status") == "余剰"){
        //   return ""
        // }else{
          return this.user_applicant;
        // }
      },
      set(v){
        this.user_applicant = v;
      }
    },
    teamApplicant:{
      get(){
        // if( this.getFieldLastValue("current_status") == "余剰"){
        //   return ""
        // }else{
          return this.team_applicant;
        // }
      },
      set(v){
        this.team_applicant = v;
      }
    },
    showModal:{
      get(){
        return this.show_modal;
      },
      set(v){
        this.show_modal = v;
      }
    },
    sessionId:{
      get(){
        return this.session_id;
      },
      set(v){
        this.session_id = v;
      }
    },
    disableBtnApply:{
      get(){
        return this.disable_btn_apply;
      },
      set(v){
        this.disable_btn_apply = v;
      }
    },
    approvalHistoryId:{
      get(){
        if(this.approval_history_id && this.approval_history_id > -1){
          return "申請No：" + this.approval_history_id;
        }else{
          return "";
        }
      },
      set(v){
        this.approval_history_id = v;
      }
    },
    approvalHistoryTorokuNumber:{
      get(){
        if(this.approval_history_toroku_number && this.approval_history_toroku_number > -1){
          return "申請No：" + this.approval_history_toroku_number;
        }else{
          return this.approvalHistoryId;
        }
      },
      set(v){
        this.approval_history_toroku_number = v;
      }
    },
    modalIsReadOnly:{
      get(){
        return this.modal_is_read_only;
      },
      set(v){
        this.modal_is_read_only = v;
      }
    },
    lastChange:{
      get(){
        return this.last_change;
      },
      set(v){
        this.last_change = v;
      }
    },
    selectedDepartment:{
      get(){
        console.log("GET selectedDepartment",this.selected_department)
        return this.selected_department;
      },
      set(v){
        console.log("SET selectedDepartment",v)
        this.selected_department = v;
      }
    },
    listTeamDepartment:{
      get(){
        return this.list_team_department;
      },
      set(v){
        this.list_team_department = v;
      }
    },
    localFields(){
      return fields;
    },
    formFields2() {
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.team_1, {}),
        ],
        col2:[
          utils.extend(fields.approver_1, {}),
        ],
        col3:[
          this.local_extend(fields.status_0, {disabled:true, read_only:true}),
        ],
        col4:[
          utils.extend(fields.status_1, {disabled:true, read_only:true}),
　　　　　 utils.extend(fields.status_2, {disabled:true, read_only:true}),
          utils.extend(fields.status_3, {disabled:true, read_only:true}),
          utils.extend(fields.status_4, {disabled:true, read_only:true}),
          utils.extend(fields.status_5, {disabled:true, read_only:true}),
          utils.extend(fields.status_6, {disabled:true, read_only:true}),
　　　　　 utils.extend(fields.status_7, {disabled:true, read_only:true}),
          utils.extend(fields.status_8, {disabled:true, read_only:true}),
          utils.extend(fields.status_9, {disabled:true, read_only:true}),
          utils.extend(fields.status_10, {disabled:true, read_only:true}),
          utils.extend(fields.status_11, {disabled:true, read_only:true}),
　　　　　 utils.extend(fields.status_12, {disabled:true, read_only:true}),
          utils.extend(fields.status_13, {disabled:true, read_only:true}),
          utils.extend(fields.status_14, {disabled:true, read_only:true}),
          utils.extend(fields.status_15, {disabled:true, read_only:true}),
          utils.extend(fields.status_16, {disabled:true, read_only:true}),
　　　　　 utils.extend(fields.status_17, {disabled:true, read_only:true}),
          utils.extend(fields.status_18, {disabled:true, read_only:true}),
          utils.extend(fields.status_19, {disabled:true, read_only:true}),
          utils.extend(fields.status_20, {disabled:true, read_only:true}),
        ],
        col5:[
          this.local_extend(fields.approver_final, {disabled:true, read_only:true}),
          // utils.extend(fields.approver_final, {}),
        ],
        col6:[
          this.local_extend(fields.status_final, {disabled:true, read_only:true}),
          // utils.extend(fields.status_final, {}),
        ],
      }
    },
    applicationMode:{
      get(){
        switch (this.application_mode) {
          case "device_embedded":
            this.fk_table_id = constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION;
            return MODE_DEVICE_EMBEDDED;
            break;
          case "user":
            this.fk_table_id = constants.TABLE_ID.USER;
            return MODE_USER;
            break;
          case "bulk_import":
            this.fk_table_id = -1;
            return MODE_BULK_IMPORT;
            break;
          case "bulk_edit_device_embedded":
            this.fk_table_id = constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION;
            return MODE_BULK_EDIT_DEVICEE_EMBEDDED;
            break;
          case "bulk_edit_certificate":
            this.fk_table_id = constants.TABLE_ID.CERTIFICATE_SOFTWARE;
            return MODE_BULK_EDIT_CERTIFICATE;
            break;
          case "inventory":
            this.fk_table_id = constants.TABLE_ID.INVENTORY;
            return MODE_INVENTORY;
            break;
          default:
            this.fk_table_id = constants.TABLE_ID.CERTIFICATE_SOFTWARE;
            return MODE_CERTIFICATE;
            break;
        }
      },
      set(v){
        this.application_mode = v;
      }
    },
    title(){
      if(this.applicationMode == MODE_USER){
        if(this.title_suffix && this.title_suffix.length > 0){
          return "申請ルート" + this.title_suffix;
        }else{
          return "申請ルート（ユーザ）";
        }
      }
       if(this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED){
        if(this.title_suffix && this.title_suffix.length > 0){
          return "申請ルート" + this.title_suffix;
        }else{
          return "申請ルート（一括編集）";
        }
      }else if(this.applicationMode == MODE_BULK_EDIT_CERTIFICATE){
        if(this.title_suffix && this.title_suffix.length > 0){
          return "申請ルート" + this.title_suffix;
        }else{
          return "申請ルート（一括編集）";
        }
      }else if(this.applicationMode == MODE_BULK_IMPORT){
        if(this.title_suffix && this.title_suffix.length > 0){
          return "申請ルート" + this.title_suffix;
        }else{
          return "申請ルート（一括取込）";
        }
      }else if(this.applicationMode == MODE_DEVICE_EMBEDDED){
        return "申請ルート（機器・組込情報）";
      }else if(this.applicationMode == MODE_INVENTORY){
        return "申請ルート（棚卸）";
      }else{
        return "申請ルート（証書情報）";
      }
    },
    localUserList:{
      get(){
        return this.local_user_list;
      },
      set(v){
        var ud =  this.userDepartment;
        this.userOptions = _.filter(v,(o)=>{ return o.department == ud && o.user_shimei != this.userShimei}).map(o => {return o.user_shimei;});
        this.teamOptions = v.map(o => {return o.team;});
        this.local_user_list = v;
      }
    },
    userDepartment() {
      return Vue.localStorage.get("userDepartment") || "";
    },

    userTeam() {
      return Vue.localStorage.get("userTeam") || "";
    },
    userShimei() {
      return Vue.localStorage.get("userShimei") || "";
    },

    userOptions:{
      get(){
        return this.user_options;
      },
      set(v){
        this.user_options = v;
      }
    },
    teamOptions:{
      get(){
        return this.team_options;
      },
      set(v){
        this.team_options = v;
      }
    },
  },
  methods: {
    local_extend(field_info,ext ={}){
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      //管理担当者を外す
      // if(this.applicationMode == MODE_INVENTORY){
      //     ext.api = '/master_user/list_user_and_team_inventory/';    
      // }

      return utils.extend(field_info,ext)
    },
    onTeamSelected(d,n){
      try {
         var obj = JSON.parse(d)
        var temp = this.selectedDepartment;
        temp[n] = obj.department;
        this.selectedDepartment = temp;
        this.lastChange = (new Date()).getTime();
      } catch (error) {
      }
    },
    showModalWindow(data) {
      if(this.showModal == true){
        return;
      }
      this.disableBtnApply = false;

      this.showModal = true;
      this.titleStyle = data.title_style || "";
      this.ref_id = data.ref_id;
      this.is_surplus = data.is_surplus || false;
      // this.approval_status = data.approval_status;
      this.applicationMode = data.application_mode;
      this.initselectedDepartment();
      this.process_import_url = data.process_import_url;
      if(data.on_finish_url_name){
        this.on_finish_url_name = data.on_finish_url_name;
      }
      if(data.title_prefix){
        this.title_prefix = data.title_prefix;
      }
      if(data.session_id){
        this.sessionId = data.session_id;
      }
      if(data.title_suffix){
        this.title_suffix = data.title_suffix;
      }
      if(data.syubetu){
        this.syubetu = data.syubetu;
      }
      if(data.list_seq_id){
        this.list_seq_id = data.list_seq_id;
      }
      if(data.modal_is_read_only){
        this.modalIsReadOnly = true;
        this.ReadOnly = true;
      }else{
        this.modalIsReadOnly = false;
        this.ReadOnly = false;
      }
      this.seq_id = data.seq_id;
      this.$ajax.post_cached_queued("/master_user/load_for_bulk_import/", {}, (err, load_for_bulk_import_data) => {
        this.localUserList = load_for_bulk_import_data;
      });
      this.$ajax.post_cached_queued("/master_belongs/list_team_and_department/", {}, (err, list_team_and_department_data) => {
        list_team_and_department_data.forEach(d=>{
          var value = JSON.stringify(d)
          d.value =value;
        })
        this.listTeamDepartment = data;
      });
      if(data.approval_history_toroku_number != false && typeof data.approval_history_toroku_number != "undefined"){
        this.approvalHistoryTorokuNumber =  data.approval_history_toroku_number
      }
      if(data.approval_history_id != false && typeof data.approval_history_id != "undefined"){
        this.approvalHistoryId = data.approval_history_id;
        var approval_history_url = "/approval_history_inventory/get/";
        if(this.applicationMode ==MODE_USER){
          approval_history_url = "/id_approval_history/get/";
        }
        var url = approval_history_url + data.approval_history_id;
        if(data.approval_history_id == -200){
          this.title_suffix = "一括取込";
          url = "/approval_history_batch_import/get_by_toroku_number/" + data.approval_history_toroku_number
        }
        this.$ajax.post(url  , {}, (err, approval_history_data) => {

          if(approval_history_data && approval_history_data.data && approval_history_data.data.applicant){
            this.userApplicant = approval_history_data.data.applicant
          }
          if(approval_history_data && approval_history_data.data && approval_history_data.data.applicant_label){
            this.userApplicant = approval_history_data.data.applicant_label
          }
          if(approval_history_data && approval_history_data.data && approval_history_data.data.applicant_team){
            this.teamApplicant = approval_history_data.data.applicant_team
          }

          if(approval_history_data && approval_history_data.body && approval_history_data.body.data == null){
            return this.prepareEmptyData();
          }
          if(this.modalIsReadOnly == false){
            return this.prepareEmptyData();
          }
          this.$store.state[this.stateCurrentRow] = approval_history_data.data;
          // Note, in this case it will save as a new record, so all current fields are set as the editing
          this.$store.state[this.stateCurrentEditing] = {};
          Object.keys(approval_history_data.data).forEach(k=>{
            if(k.indexOf("status") == 0 || k.indexOf("approver") == 0 || k.indexOf("team") == 0){
              var val = approval_history_data.data[k] || false;
              var current_status = false
              // Note, Affected when changing the maximum number
              if(/\_[1-9]?\d/.test(k)){
                current_status = approval_history_data.data["current_status"] || false
              }
              // if(val && current_status != "余剰" ){
              if(val){
                this.$store.state[this.stateCurrentRow][k] = val;
              // }else{
              //   this.$store.state[this.stateCurrentRow][k] = "";
              }
            }
          })
          this.local_seq_id = approval_history_data.data.seq_id;
          this.is_new = false;
          this.$store.state[this.stateIsEditingNew] = false;
          this.readOnly = (this.modalIsReadOnly == true)? true:false;
        });

      }else if (this.modalIsReadOnly == true){
        this.readOnly = true;
        this.prepareEmptyData(false);
        this.teamApplicant = this.userTeam;
        this.userApplicant = this.userShimei;
      }else{
        this.prepareEmptyData();
        this.readOnly = false;
        this.approvalHistoryId = "";
        this.teamApplicant = this.userTeam;
        this.userApplicant = this.userShimei;
      }
    },
    prepareEmptyData(is_new = true){
      this.local_seq_id = Number.MAX_SAFE_INTEGER;
      this.$store.state[this.stateCurrentRow] = {
        seq_id : this.local_seq_id
      }
      Object.keys(fields).forEach(f =>{
        this.$store.state[this.stateCurrentRow][fields[f].id] = "";
        this.$store.state[this.stateCurrentEditing][fields[f].id] = "";
      })
      if(is_new){
        setTimeout(() => {
          this.approvalHistoryId = "";
          this.$store.state[this.stateIsEditingNew] = true;
          this.read_only = false;
          this.is_new = true;
        }, 300);
      }
    },
    closed(mode) {
      this.showModal = false;
      if(typeof mode != "undefined"){
        this.$emit('done',mode);
      }
    },
    //  onDeviceEmbeddedInformationAddCheckConfirm(){
    //   this.read_only = false;
    // },
    getSyubetuFromApplicationMode(){
      var ret = ""
      switch(this.applicationMode) {
        case MODE_DEVICE_EMBEDDED:
          ret = constants.SYUBETU.DEVICE;
          break;
        case MODE_CERTIFICATE:
          ret = constants.SYUBETU.CERTIFICATE;
          break;
        case MODE_USER:
          ret = constants.SYUBETU.USER;
          break;
        case MODE_INVENTORY:
          ret = constants.SYUBETU.INVENTORY;
          break;
        default:
          ret = constants.SYUBETU.CERTIFICATE;
          break;
      }
      return ret;
    },
    onSave(mode){
      if(mode == "yes"){
        debug_msg_bulk("On Save",{mode:this.applicationMode,url:this.process_import_url})
        // As the rules are not clear, will do it manually here, and will not use the commonSaveInfo
        if(this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED){

          var changes= {};
          Object.keys(fields).forEach(f =>{
            if(f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0){
              var v = this.$store.state[this.stateCurrentEditing][fields[f].id];
              if(v && v.length > 0){
                changes[f] =  v;
              }
            }
          })
          var obj = {list_seq_id:this.list_seq_id,changes};
          if(this.sessionId != false){
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(this.process_import_url, obj, (err, result) => {
            if(err){
              this.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              this.disableBtnApply = false;
            }else{
              return this.onConfirmExecuteProcess();
            }
          })
        }
        else if(this.applicationMode == MODE_BULK_EDIT_CERTIFICATE){
          var changes= {};
          Object.keys(fields).forEach(f =>{
            if(f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0){
              var v = this.$store.state[this.stateCurrentEditing][fields[f].id];
              if(v && v.length > 0){
                changes[f] =  v;
              }
            }
          });
          var obj = {list_seq_id:this.list_seq_id,changes};
          if(this.sessionId != false){
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(this.process_import_url, obj, (err, result) => {
            if(err){
              this.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              this.disableBtnApply = false;
            }else{
              return this.onConfirmExecuteProcess();
            }
          })
        }
        else if(this.applicationMode == MODE_BULK_IMPORT){
          // In case of MODE_BULK_IMPORT, call the process URL, and all tasks wil be there.
          // All changes reated to the approval_history, should be done at te import process_import_url URL.
          var changes = {};
          Object.keys(fields).forEach(f =>{
            if(f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0){
              var v = this.$store.state[this.stateCurrentEditing][fields[f].id];
              if(v && v.length > 0){
                changes[f] =  v;
              }
            }
          });
          var obj = {syubetu:this.syubetu,changes};
          if(this.sessionId != false){
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(this.process_import_url, obj, (err, result) => {
            if(err){
              this.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              this.disableBtnApply = false;
            }else{
              return this.onConfirmExecuteProcess();
            }
          })
        }else if(this.applicationMode == MODE_CERTIFICATE){
          // Case not the MODE_BULK_IMPORT, then execute the approval_history set.
          var changes= {
            ref_id:this.ref_id,
            syubetu:this.getSyubetuFromApplicationMode(),
            approval_status: "申請中",
            application_mode:this.applicationMode,
            fk_tab:constants.TABLE_ID.CERTIFICATE_SOFTWARE,
            fk_id:this.seq_id,
            update_name:"",
            update_time:null,
            create_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss")
          }
          Object.keys(fields).forEach(f =>{
            if(f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0){
              var v = this.$store.state[this.stateCurrentEditing][fields[f].id];
              if(v && v.length > 0){
                changes[f] =  v;
              }
            }
          });
          var obj = {changes};
          if(this.sessionId != false){
            obj.session_id = this.sessionId;
          }
          this.$ajax.post("/approval_history/set/" + Number.MAX_SAFE_INTEGER, obj, (err, response) => {
            console.log("onSave approval _history",{response})
            if(err){
              this.$notify({
                title: "データの保存に失敗しました。",
                text:err,
                type: "error",
                duration: 10000
              });
              this.disableBtnApply = false;
            }else{
              this.$ajax.post("/certificate_software/set/" + this.seq_id, {system_change:true,changes:{approval_status:"申請中",approval_status_flag:1,retraction_reason:""}}, (err, response2) => {
                if(err){
                  this.$notify({
                    title: "データの保存に失敗しました。",
                    text:err,
                    type: "error",
                    duration: 10000
                  });
                  this.disableBtnApply = false;
                }else{
                  this.saveApplicationFlow(response.data.seq_id ,()=>{
                    this.onConfirmExecuteProcess();
                  })
                }
              });
            }
          });
        }else if(this.applicationMode == MODE_INVENTORY){
          // Case not the MODE_BULK_IMPORT, then execute the approval_history set.
          var changes= {
            ref_id: this.ref_id,
            control_number:(!this.ref_id || this.ref_id.indexOf("BY_SEQ_ID::") == 0)?"":this.ref_id,
            approval_status: "申請中",
            syubetu:this.getSyubetuFromApplicationMode(),
            application_mode:this.applicationMode,
            fk_tab:this.fk_table_id,
            fk_id:this.seq_id,
            update_name:"",
            update_time:null,
            create_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss")
          }
          Object.keys(fields).forEach(f =>{
            if(f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0){
              var v = this.$store.state[this.stateCurrentEditing][fields[f].id];
              if(v && v.length > 0){
                changes[f] =  v;
              }
            }
          });

          var approval_history_url = "/approval_history_inventory/set/";

          var obj = {changes};
          if(this.sessionId != false){
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(approval_history_url + Number.MAX_SAFE_INTEGER, obj, (err, response) => {
            console.log("onSave approval _history",{response})
            if(err){
              this.$notify({
                title: "データの保存に失敗しました。",
                text:err,
                type: "error",
                duration: 10000
              });
              this.disableBtnApply = false;
            }else{
              var api_url = "inventory_report";
              this.$ajax.post("/"+api_url+"/set/" + this.seq_id, {system_change:true,changes:{approval_status:"申請中",approval_status_flag:1,retraction_reason:""}}, (err, response2) => {
                console.log("onSave 2 " + api_url,{response2})
                if(err){
                  this.$notify({
                    title: "データの保存に失敗しました。",
                    text:err,
                    type: "error",
                    duration: 10000
                  });
                  this.disableBtnApply = false;
                }else{
                  this.saveApplicationFlow(response.data.seq_id ,()=>{
                    this.onConfirmExecuteProcess();
                  })
                }
              });
            }
          });
        }else{
          // Case not the MODE_BULK_IMPORT, then execute the approval_history set.
          var changes= {
            ref_id: this.ref_id,
            control_number:(!this.ref_id || this.ref_id.indexOf("BY_SEQ_ID::") == 0)?"":this.ref_id,
            approval_status: "申請中",
            syubetu:this.getSyubetuFromApplicationMode(),
            application_mode:this.applicationMode,
            fk_tab:this.fk_table_id,
            fk_id:this.seq_id,
            update_name:"",
            update_time:null,
            create_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss")
          }
          Object.keys(fields).forEach(f =>{
            if(f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0){
              var v = this.$store.state[this.stateCurrentEditing][fields[f].id];
              if(v && v.length > 0){
                changes[f] =  v;
              }
            }
          });


          var approval_history_url = "/approval_history/set/";
          if(this.applicationMode ==MODE_USER){
            approval_history_url = "/id_approval_history/set/";
          }

          var obj = {changes};
          if(this.sessionId != false){
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(approval_history_url + Number.MAX_SAFE_INTEGER, obj, (err, response) => {
            console.log("onSave approval _history",{response})
            if(err){
              this.$notify({
                title: "データの保存に失敗しました。",
                text:err,
                type: "error",
                duration: 10000
              });
              this.disableBtnApply = false;
            }else{
              var api_url = (this.applicationMode == MODE_DEVICE_EMBEDDED)?"device_embedded_information":"certificate_information";
              this.$ajax.post("/"+api_url+"/set/" + this.seq_id, {system_change:true,changes:{approval_status:"申請中",approval_status_flag:1,retraction_reason:""}}, (err, response2) => {
                console.log("onSave 2 " + api_url,{response2})
                if(err){
                  this.$notify({
                    title: "データの保存に失敗しました。",
                    text:err,
                    type: "error",
                    duration: 10000
                  });
                  this.disableBtnApply = false;
                }else{
                  this.saveApplicationFlow(response.data.seq_id ,()=>{
                    this.onConfirmExecuteProcess();
                  })
                }
              });
            }
          });
        }
      }else if(mode== "no"){
        this.disableBtnApply = false;
      }
    },
    saveApplicationFlow(approval_history_seq_id,cb){
      return cb(null);

      // var changes= {
      //   fk_tab:constants.TABLE_ID.APPROVAL_HISTORY,
      //   fk_id:approval_history_seq_id,
      // }
      // Object.keys(fields).forEach(f =>{
      //   if(f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0){
      //     var v = this.$store.state[this.stateCurrentEditing][fields[f].id];
      //     if(v && v.length > 0){
      //       changes[f] =  v;
      //     }
      //   }

      // })
      // this.$ajax.post("/approval_history/set_application_flow/" + approval_history_seq_id, {changes}, (err, response) => {
      //   return cb(err)
      // })
    },
    onLocalApplication(){
      this.$notify({clean:true})
      // var approver = this.$store.state[this.stateCurrentEditing]["approver_1"] || "";
      // var team = this.$store.state[this.stateCurrentEditing]["team_1"] || "";
      // if(team == "" || approver == ""){
      //   this.$notify({
      //     title: "Please select 所属チーム and 承認者",
      //     text:"",
      //     type: "error",
      //     duration: 10000
      //   });
      //   return;
      // }

      this.disableBtnApply = true;
      bus.$emit("confirmDeviceEmbeddedInformation",{
        message: "よろしいですか？",
        title: "申請を行います。",
        yes_label: "申請",
        no_label: "戻る",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
    onConfirmExecuteProcess(){
      var message = "機器・組込情報を申請しました。";
      if(this.applicationMode == MODE_CERTIFICATE){
        message = "証書情報を申請しました。";
        if( this.is_surplus == true){
          message = "余剰ライセンスを申請しました。";
        }
      }else if(this.applicationMode == MODE_USER){
        message = "ユーザを申請しました。";
      }else if(this.applicationMode == MODE_INVENTORY){
        this.showModal = false;        
        this.show_modal = false;
        this.$emit('done',"yes");
        return
    
        message = "棚卸報告を申請しました。";
      }
      if((this.applicationMode == MODE_BULK_IMPORT  || this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED  || this.applicationMode == MODE_BULK_EDIT_CERTIFICATE) && this.title_prefix  && this.title_prefix.length > 0){
        message = this.title_prefix + "を申請しました。";
      }
      bus.$emit("applicationConfirmatioModal",{
        title: "",
        message: message,
        yes_label: "",
        no_label: "OK",
        yes_color:"",
        no_color:"default",
        model_height:"50"
      })
    },
    // backToList(){
    //   Vue.localStorage.remove('bulk_edit_' + this.local_page_id);
    //   return this.$router.go(-1);
    // },
    onSaveApplicationConfirm(){
      this.showModal = false;
      var on_finish_go_to ="page_0010_device_embedded_information"
      if(this.applicationMode == MODE_CERTIFICATE){
        on_finish_go_to ="page_0040_certificate_software"
        if( this.is_surplus == true){
          on_finish_go_to ="page_0020_surplus_license"
        }
      }else if(this.applicationMode == MODE_INVENTORY){
        return
        
        // on_finish_go_to ="page_0072_inventory_report_check"        
      }else if(this.applicationMode == MODE_USER){
        on_finish_go_to ="page_0041_master_user"
      }
      if(this.on_finish_url_name && this.on_finish_url_name .length > 0){
        on_finish_go_to = this.on_finish_url_name ;
      }
      // if(this.on_finish_url_name == "close"){
      //   return this.backToList();
      // }
      setTimeout(() => {
        this.$router.push({
          name: on_finish_go_to
        });
      }, 500);
    },
    initselectedDepartment(){
      this.selected_department = [];
      for(var i = 0; i < this.MaxNumberApproval;i++){
        this.selected_department.push(this.userDepartment);
      }
    }
  },
  props: {
    tag: { type: String, default: "applicationConfimationModal" }
  },
  mounted() {
    bus.$on(this.$props.tag, this.showModalWindow);
    this.initselectedDepartment();
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);

  }
};
</script>
<style>
.no_focus::-moz-selection { /* Code for Firefox */
  background: white;
}

.no_focus::selection {
  background: white;
}
</style>
<style scoped>

.overflow-modal-body {
  overflow-y: auto;
  border: solid 1px #d4d4d4;
}
th{
  background: #aba7a7;
  color: white;
  padding:2px 3px;
}
tr{
  height: 25px;
}
td{
  padding:4px 3px;
}
</style>



// WEBPACK FOOTER //
// application-confirmation-modal-inventory.vue?5287a88e